/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
/* eslint-disable react/no-multi-comp */
import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  IconButton,
  Tooltip,
  Typography,
} from '@mui/material';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';

export const CHART_HEIGHT = 320;
export const FOCUS_CHART_HEIGHT = 520;

export const ChartEmpty = ({ message }) => (
  <Box
    sx={{
      height: CHART_HEIGHT,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'text.secondary',
      gap: 1,
    }}
  >
    <BarChartOutlinedIcon sx={{ fontSize: 40, opacity: 0.4 }} />
    <Typography variant="body2">{message}</Typography>
  </Box>
);

ChartEmpty.propTypes = {
  message: PropTypes.string.isRequired,
};

export const ChartCard = ({ title, action, onExpand, contentSx, children }) => (
  <Card variant="outlined" sx={{ borderRadius: 2, height: '100%' }}>
    <CardHeader
      title={title}
      titleTypographyProps={{ variant: 'h6' }}
      action={
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          {action}
          {onExpand && (
            <Tooltip title="Expandir">
              <IconButton size="small" onClick={onExpand} aria-label="Expandir gráfico">
                <OpenInFullIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      }
      sx={{ pb: 0 }}
    />
    <CardContent sx={{ pt: 1, pb: 2, ...contentSx }}>{children}</CardContent>
  </Card>
);

ChartCard.propTypes = {
  title: PropTypes.string.isRequired,
  action: PropTypes.node,
  onExpand: PropTypes.func,
  contentSx: PropTypes.object,
  children: PropTypes.node.isRequired,
};

ChartCard.defaultProps = {
  action: null,
  onExpand: null,
  contentSx: null,
};
